<template>
  <div class="coupon-info-container">
    <div>已使用优惠券，<span class="red">减{{couponDiscountValue}}元</span></div>
    <div class="red count-down"><van-count-down
      :time="useEndTime - new Date().getTime()"
      :format="dateFormat"
      @finish="$emit('updateTime')"
    />后失效</div>
  </div>
</template>


<script>
export default {
  name: 'coupon-info',
  props: {
    couponDiscountValue: {
      type: [Number, String],
      default: null
    },
    useEndTime: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    dateFormat () {
      if (this.useEndTime - new Date().getTime() > 86400000) {
        return 'DD天HH:mm:ss'
      } else if (this.useEndTime - new Date().getTime() > 3600000) {
        return 'HH:mm:ss'
      } else {
        return 'mm:ss'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

   .coupon-info-container {
      position: absolute;
      width: 670px;
      height: 96px;
      background: #FEE9E8;
      border-radius: 14px 14px 0 0;
      padding:12px 16px;
      font-size: 22px;
      display: flex;
      justify-content: space-between;
      pointer-events: none;
      .red {
        color: #FF4633;
      }
      .count-down {
        display: flex;
      }
      .van-count-down {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF4633;
        line-height: 33px;
      }
    }
</style>